Core.DeliveryCounter = function(elem) {

    /*


        DATASET


     */

    function hasDataset(elem, name) {
        return elem &&
               elem.dataset &&
               typeof elem.dataset[name] !== 'undefined';
    }

    function warnData(name) {
        console.warn('DeliveryCounter data for ' + name + ' missing');
        return;
    }

    function getDataset(elem, name) {
        return hasDataset(elem, name)
                    ? elem.dataset[name]
                    : warnData(name);
    }


    /*


        TIME


     */


    /**
     * utcToLocale
     *
     * @param  string date UTC time '2011-06-29T16:52:48.000Z'
     * @return Date
     */
    function utcToLocale(utcDate) {
        return new Date(utcDate);
    }

    function dayOfTheWeek(utcDate) {
        var d = new Date(utcDate);
        var week = new Array(7);

        week[0] = "Sun";
        week[1] = "Mon";
        week[2] = "Tue";
        week[3] = "Wed";
        week[4] = "Thu";
        week[5] = "Fri";
        week[6] = "Sat";

        return week[d.getDay()];
    }

    function getDateElem(utcDate) {
        var d = new Date(utcDate);

        return {
            dayOfWeek: dayOfTheWeek(utcDate),
            day: d.getDate(),
            month: d.getMonth() + 1,
            year: d.getFullYear()
        };
    }

    function isFutureDate(endtime) {
        var total = (Date.parse(endtime) - Date.parse(new Date()));

        return total > 0;
    }

    function getTimeRemaining(endtime) {
        var SEC = 1000,
            MIN = SEC * 60,
            HRS = MIN * 60,
            DAY = HRS * 24;

        var total = (Date.parse(endtime) - Date.parse(new Date()));

        var d = Math.floor(total / DAY);
        var h = Math.floor((total % DAY) / HRS) + (d * 24);
        var m = Math.floor((total % HRS) / MIN);
        var s = Math.floor((total % MIN) / SEC);

        return {
            h,
            m,
            s
        };
    }

    function getLabel(endtime) {
        if (getTimeRemaining(endtime).h > 0) {
            return getTimeRemaining(endtime).h + 'h';
        }

        if (getTimeRemaining(endtime).m > 0) {
            return getTimeRemaining(endtime).m + 'm';
        }

        if (getTimeRemaining(endtime).s > 0) {
            return getTimeRemaining(endtime).s + 's';
        }

        return '---';
    }


    /*


        TMPL


     */

    function counterTmlp(data) {
        return `<div class="deliveryCounter--largeAnimation">
                <div class="deliveryCounter--large">
                    <div class="deliveryCounter--largeDelivery">
                        <span class="deliveryCounter--largeLabel">CUT OFF</span>
                        <span class="deliveryCounter--largeLabel2">${data.dayOfWeek} ${data.day}/${data.month}/${data.year}</span>
                    </div>

                    <div class="deliveryCounter--largeTimer">
                        <span>${data.h}h</span>
                        <span>${data.m}m</span>
                        <span>${data.s}s</span>
                    </div>
                </div>
            </div>

            <div class="deliveryCounter--smallAnimation">
                <div class="deliveryCounter--small">
                    <div class="deliveryCounter--smallImg">
                        <svg aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="truck"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 640 512"
                            class="svg-inline--fa fa-truck fa-w-20 fa-flip-horizontal fa-5x"
                            style="width: 43px; color: #6c6c6e;">
                            <path fill="currentColor" d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z" class=""></path>
                        </svg>
                    </div>
                    <div class="deliveryCounter--smallLabel">${data.label}</div>
                </div>
            </div>
        `;
    }

    var el = {
        elem: elem,
    };

    var data = {
        api: getDataset(elem, 'api'),
        nextCutOff: [],
        dayOfWeek: '---',
        day: '--',
        month: '--',
        year: '----',

        h: '--',
        m: '--',
        s: '--',
        label: '---',
    };



    // Methods
    var m = {
        init: function() {
            if (typeof data.api === 'undefined') {
                return;
            }

            m.boot();
        },


        boot: function() {
            m.onClickCounter();
            m.fetchData();

            setInterval(function() {
                m.getNextData()
                    ? m.calculateData(m.getNextData())
                    : m.resetData();

                m.getNextData()
                    ? m.updateCounterTmpl()
                    : m.cleanCounterTmpl();
            }, 1000);
        },

        getNextData: function() {
            return data.nextCutOff &&
                    data.nextCutOff.length > 0 &&
                    data.nextCutOff.filter(isFutureDate).length > 0 &&
                    data.nextCutOff.filter(isFutureDate)[0];
        },

        onClickCounter: function() {
            function swapClasses(e) {
                e.currentTarget.classList.toggle('deliveryCounter--showLarge');
                e.currentTarget.classList.toggle('deliveryCounter--showSmall');
            }

            el.elem.addEventListener('click', swapClasses);
        },

        updateCounterTmpl: function() {
            el.elem.innerHTML = counterTmlp(data);
            el.elem.style.display = 'block';

            (parseInt(data.h) >= 23)
                ? el.elem.classList.add('deliveryCounter--green')
                : el.elem.classList.add('deliveryCounter--red');

            (data.h === '--')
                && ( el.elem.classList.remove('deliveryCounter--green')
                   , el.elem.classList.remove('deliveryCounter--red'));


            m.fire('delivery-counter:show');
        },

        cleanCounterTmpl: function() {
            el.elem.innerHTML = '';
            el.elem.style.display = 'none';

            m.fire('delivery-counter:hide');
        },

        calculateData: function(utcDate) {
            data['dayOfWeek'] = getDateElem(utcDate).dayOfWeek;
            data['day'] = getDateElem(utcDate).day;
            data['month'] = getDateElem(utcDate).month;
            data['year'] = getDateElem(utcDate).year;

            data['h'] = getTimeRemaining(utcDate).h;
            data['m'] = getTimeRemaining(utcDate).m;
            data['s'] = getTimeRemaining(utcDate).s;

            data['label'] = getLabel(utcDate);
        },

        resetData: function() {
            data['dayOfWeek'] = '---';
            data['day'] = '--';
            data['month'] = '--';
            data['year'] = '----';

            data['h'] = '--';
            data['m'] = '--';
            data['s'] = '--';
            data['label'] = '---';
        },

        fetchData: function() {
            $.ajax({
                url: data.api,
                processData: false,
                contentType: false,
                success: function(resp) {
                   data.nextCutOff = (resp && resp.dates) ? resp.dates : [];
                },
                error: function(error) {

                }
            });
        },

        fire: function(eventName) {
            var ev = new CustomEvent(eventName);
            document.dispatchEvent(ev);
        },

    };

    return m;

};
